import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Alert, Heading, Box, Text, Link, Image } from 'roo-ui/components';
import { qantasQff, qantasBusinessRewards } from 'roo-ui/logos';
import { contactUsLinkSelected } from 'lib/gaTracking/crossPageEvents';
import OriginalLoadingButton from 'components/LoadingButton';
import { CONTACT_US_URL } from 'config/constants';
import { NumberInput } from 'components/Form';

export const ErrorAlertMessage = () => (
  <Alert.error m={2} aria-live="assertive">
    <Heading.h5>Your guest detail changes could not be saved</Heading.h5>
    <Text>
      A technical issue occurred while your changes were being saved. Please{' '}
      <Link target="_blank" href={`${CONTACT_US_URL}`} onClick={contactUsLinkSelected}>
        contact us
      </Link>{' '}
      or try again later.
    </Text>
  </Alert.error>
);

ErrorAlertMessage.displayName = 'ErrorAlertMessage';

export const Fields = styled(Box)`
  position: relative;
  padding-bottom: 160px;

  ${themeGet('mediaQueries.0')} {
    padding-bottom: 0;
  }
`;

Fields.displayName = 'Fields';

export const NameFootnote = () => (
  <Text fontSize="14px">
    <Link target="_blank" href={`${CONTACT_US_URL}`} onClick={contactUsLinkSelected}>
      Contact us
    </Link>{' '}
    to change the guest name
  </Text>
);

NameFootnote.displayName = 'NameFootnote';

const StyledBox = styled(Box)`
  position: relative;
  padding: 0;

  img {
    position: absolute;
    top: ${themeGet('space.3')};
    right: ${themeGet('space.2')};
    width: 92px;
  }
`;

const NumberInputWithImage = styled(NumberInput)`
  padding-right: 112px;
`;

const InputWithLogo = ({ children, ...props }) => (
  <StyledBox>
    <NumberInputWithImage {...props} />
    {children}
  </StyledBox>
);

export const QffInput = (props) => (
  <InputWithLogo {...props}>
    <Image src={qantasQff} alt="Qantas Frequent Flyer Logo" />
  </InputWithLogo>
);

QffInput.displayName = 'QffInput';

export const QbrInput = (props) => (
  <InputWithLogo {...props}>
    <Image src={qantasBusinessRewards} alt="Qantas Business Rewards Logo" />
  </InputWithLogo>
);

export const FormActions = styled(Box)`
  background: white;
  padding: ${themeGet('space.6')} ${themeGet('space.4')} ${themeGet('space.4')};
  box-shadow: 0px -2px 4px 0px #e6e6e6;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;

  ${themeGet('mediaQueries.0')} {
    padding: 0 ${themeGet('space.4')};
    box-shadow: none;
    position: inherit;
  }
`;

FormActions.displayName = 'FormActions';

export const LoadingButton = styled(OriginalLoadingButton)`
  min-width: 178px;
`;

export const Column = (props) => <Box width={[1, 1 / 3]} my={2} {...props} />;
